import throttle from "lodash/throttle";

class IFrame {
    constructor() {
        const throttledResize = throttle(IFrame.resize, 500);

        IFrame.resize();

        window.addEventListener("resize", throttledResize);

        // Check for changes in the DOM and trigger a resize
        const observer = new MutationObserver(() => {
            throttledResize();
        });

        observer.observe(document, {
            attributes: true,
            childList: true,
            subtree: true,
        });

        // Resize every 5 seconds
        setInterval(() => {
            IFrame.resize();
        }, 5000);

        window.addEventListener("message", this.receiveMessage, false);
    }

    static resize() {
        setTimeout(() => {
            let newHeight = document.body.scrollHeight;

            newHeight = Math.round(newHeight);

            const urlParams = new URLSearchParams(window.location.search);
            const uid = urlParams.get("uid");

            let message = {
                resize: newHeight,
                uid: uid,
            };

            window.parent.postMessage(JSON.stringify(message), "*");
        }, 200);
    }

    receiveMessage(e) {
        if (e.data.basket_offers) {
            if (
                $(".SpektrixPage.Basket2").length &&
                $(".Item.Instance").length
            ) {
                $(".Savings").after(e.data.basket_offers);
            }
        }

        if (e.data.gift_amount) {
            $("input.MoneyTextBox").val(Number(e.data.gift_amount));
        }

        if (e.data.origin) {
            origin = e.data.origin;

            if ($(".LoginLogout .Account_Link .Link")) {
                let el = $(".LoginLogout .Account_Link:first .Link");
                el.attr("href", `${e.data.origin}/register`);
                el.attr("target", "_top");
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new IFrame();
});

export default IFrame;
